import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api/client'

// ── Types ─────────────────────────────────────────────────────────────────────

export interface KPIDashboard {
  facturacion_mes_actual: number
  facturacion_mes_anterior: number
  variacion_facturacion_pct: number | null
  turnos_totales: number
  turnos_completados: number
  turnos_cancelados: number
  tasa_ocupacion_pct: number
  ticket_promedio: number
  presupuestos_creados: number
  presupuestos_confirmados: number
  tasa_conversion_pct: number
  top_procedimientos: { nombre: string; cantidad: number; facturacion: number }[]
  pacientes_nuevos: number
  pacientes_nuevos_mes_anterior: number
  pacientes_recurrentes: number
  no_shows: number
  tasa_no_show_pct: number
}

export interface KPIProfesional {
  profesional_id: number
  nombre: string
  turnos_completados: number
  facturacion: number
  tasa_ocupacion_pct: number
}

// ── Query keys ────────────────────────────────────────────────────────────────

export const kpiKeys = {
  dashboard: ['kpis', 'dashboard'] as const,
  profesionales: ['kpis', 'profesionales'] as const,
} as const

// ── Hooks ─────────────────────────────────────────────────────────────────────

export function useKPIs() {
  return useQuery<KPIDashboard>({
    queryKey: kpiKeys.dashboard,
    queryFn: () => apiFetch<KPIDashboard>('/kpis/dashboard/'),
    staleTime: 5 * 60 * 1000, // 5 min
  })
}

export function useKPIsProfesionales() {
  return useQuery<KPIProfesional[]>({
    queryKey: kpiKeys.profesionales,
    queryFn: () => apiFetch<KPIProfesional[]>('/kpis/por-profesional/'),
    staleTime: 5 * 60 * 1000,
  })
}
